import { classicSeries } from '@/mocks/comicData';
import ComicCard from './ComicCard';

export default function ClassicSection() {
  return (
    <section id="classic" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-secondary-700">
              <i className="ri-archive-drawer-line"></i>经典全本
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">一口气读完的经典全本</h2>
            <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-600 md:text-base">
              已完结的国漫日漫经典，分类整理好，无需等待更新，想追的剧情一次看个够。
            </p>
          </div>
          <a
            href="#category"
            className="whitespace-nowrap text-sm font-semibold text-secondary-700 hover:text-primary-600"
          >
            浏览全本分类 <i className="ri-arrow-right-line align-middle"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {classicSeries.map((item) => (
            <ComicCard key={item.id} item={item} showType />
          ))}
        </div>
      </div>
    </section>
  );
}